import { useState, useEffect } from 'react';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Card, Typography, Stack, Box, Button, Dialog, DialogTitle, DialogContent } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';
import axios from '../../../../utils/axios';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 24,
  border: '1px solid #F1F5F9',
  boxShadow: 'none',
  background: `linear-gradient(135deg, ${theme.palette.grey[900]} 0%, ${theme.palette.grey[800]} 100%)`,
  color: theme.palette.common.white,
  position: 'relative',
  overflow: 'hidden',
  '&:before': {
    content: '""',
    position: 'absolute',
    top: -20,
    right: -20,
    width: 100,
    height: 100,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.05)',
  }
}));

// ----------------------------------------------------------------------

export default function YangaAppDownloadCard() {
  const [open, setOpen] = useState(false);
  const [appLinks, setAppLinks] = useState({ playstore_url: '', appstore_url: '' });

  useEffect(() => {
    axios.get('/api/secure/discount/system').then(data => {
      setAppLinks({
        playstore_url: data.data?.playstore_url || '',
        appstore_url: data.data?.appstore_url || ''
      });
    }).catch(() => {});
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <RootStyle>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box sx={{ 
              width: 48, 
              height: 48, 
              borderRadius: '16px', 
              bgcolor: 'rgba(255,255,255,0.1)', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center' 
            }}>
              <Iconify icon="eva:cloud-download-outline" width={24} height={24} />
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Amtpay Mobile</Typography>
              <Typography variant="caption" sx={{ opacity: 0.7, fontWeight: 600 }}>Get the best experience</Typography>
            </Box>
          </Stack>

          <Button 
            fullWidth 
            variant="contained" 
            onClick={handleOpen}
            sx={{ 
              bgcolor: '#FFF', 
              color: '#000', 
              borderRadius: '12px',
              fontWeight: 700,
              py: 1.2,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }
            }}
          >
            Download Our App
          </Button>
        </Stack>
      </RootStyle>

      <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: '24px', p: 1, maxWidth: 400 } }}>
        <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>Choose Platform</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>Select your device operating system</Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Button
              fullWidth
              size="large"
              variant="outlined"
              href={appLinks.playstore_url || '#'}
              target="_blank"
              startIcon={<Iconify icon="logos:google-play-icon" width={24} />}
              sx={{ 
                py: 2, 
                borderRadius: '16px', 
                justifyContent: 'flex-start', 
                px: 3,
                borderWidth: '2px',
                '&:hover': { borderWidth: '2px' }
              }}
            >
              <Box sx={{ textAlign: 'left', ml: 1 }}>
                <Typography variant="caption" sx={{ display: 'block', opacity: 0.6, lineHeight: 1 }}>Download for</Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Android (Play Store)</Typography>
              </Box>
            </Button>

            <Button
              fullWidth
              size="large"
              variant="outlined"
              href={appLinks.appstore_url || '#'}
              target="_blank"
              startIcon={<Iconify icon="logos:apple-app-store" width={24} />}
              sx={{ 
                py: 2, 
                borderRadius: '16px', 
                justifyContent: 'flex-start', 
                px: 3,
                borderWidth: '2px',
                '&:hover': { borderWidth: '2px' }
              }}
            >
              <Box sx={{ textAlign: 'left', ml: 1 }}>
                <Typography variant="caption" sx={{ display: 'block', opacity: 0.6, lineHeight: 1 }}>Download for</Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>iOS (App Store)</Typography>
              </Box>
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
